import React, { useEffect, useState } from 'react';
import axios from 'axios';
import CalenderLinks from '../../../components/CalanderLinks/CalanderLinks';
import Footer from '../../../components/Footer/Footer';
import InnerNav from '../../../components/InnerNav/InnerNav';
import './Shardiya.scss';

const Shardiya = () => {
  const currentYear = new Date().getFullYear();
  const [year, setYear] = useState(currentYear);
  const [navratriData, setNavratriData] = useState([]);
  const [loading, setLoading] = useState(false);

    // temporary values (for input fields)
  const [tempYear, setTempYear] = useState(currentYear);

    // --- Modal state ---
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

const eventSignificanceMap = {
  'Ghatasthapana': 'Beginning of Navratri by invoking Goddess Durga into a Kalash.',
  'Shailputri Puja': 'Worship of Goddess Shailputri, the first form of Durga.',
  'Chandra Darshana': 'Sight of the moon for spiritual prosperity.',
  'Brahmacharini Puja': 'Worship of Goddess Brahmacharini for wisdom and penance.',
  'Sindoor Tritiya': 'Traditionally linked to sindoor application, a sign of marital bliss.',
  'Chandraghanta Puja': 'Worship of Goddess Chandraghanta for courage and protection.',
  'Vinayaka Chaturthi': 'Worship of Lord Ganesha for obstacle removal.',
  'Kushmanda Puja': 'Worship of Goddess Kushmanda who created the universe.',
  'Upang Lalita Vrat': 'Observed for devotion and blessings from Lalita Devi.',
  'Skandamata Puja': 'Worship of Goddess Skandamata, mother of Kartikeya.',
  'Katyayani Puja': 'Worship of Goddess Katyayani, destroyer of evil.',
  'Saraswati Avahan': 'Invocation of Goddess Saraswati, the goddess of wisdom.',
  'Kalaratri Puja': 'Worship of fierce form Kalaratri who destroys ignorance and darkness.',
  'Saraswati Puja': 'Worship of the goddess of learning and arts.',
  'Durga Ashtami': 'Most powerful day of Navratri, worshipping Mahagauri.',
  'Mahagauri Puja': 'Worship of the fair and calm form of Durga.',
  'Sandhi Puja': 'Crucial time between Ashtami and Navami, considered highly sacred.',
  'Maha Navami': 'Final worship before Durga’s victory; important puja rituals performed.',
  'Ayudha Puja': 'Worship of tools, vehicles, and weapons for success and safety.',
  'Navami Homa': 'Sacred fire ritual to conclude Navratri pujas.',
  'Navratri Parana': 'Completion of Navratri fasting and rituals.',
  'Durga Visarjan': 'Immersion of Goddess Durga idol signifying her return.',
  'Vijayadashami': 'Victory of good over evil; celebrated as Dussehra.'
};

  // --- Long detailed popups ---
  const popups = {
    'Ghatasthapana': 'Ghatasthapana marks the ceremonial beginning of Shardiya Navratri. Devotees install a sacred Kalash (metal or clay pot) symbolizing Goddess Durga and place holy items like rice, coins, and betel leaves inside. It signifies the invocation of divine energy and prepares the household spiritually for the festival.',
    'Shailputri Puja': 'On this day, Goddess Shailputri, the first form of Durga, is worshipped. She represents purity, devotion, and the power of nature. Devotees offer flowers, fruits, and recite specific mantras to seek blessings for wisdom, health, and protection from negative energies.',
    'Chandra Darshana': 'Chandra Darshana is observed for spiritual prosperity by sighting the moon after new moon or Amavasya. Devotees perform rituals to honor the moon, which is believed to influence emotional well-being and spiritual progress.',
    'Brahmacharini Puja': 'Goddess Brahmacharini, symbolizing penance and austerity, is worshipped. Devotees fast and chant hymns, seeking wisdom, courage, and self-discipline. This puja is believed to grant knowledge, strength, and fulfillment of righteous desires.',
    'Sindoor Tritiya': 'Sindoor Tritiya is celebrated mostly by married women, applying sindoor to the Goddess and each other. It symbolizes marital bliss, love, prosperity, and longevity of husbands while reinforcing social and spiritual bonds among women.',
    'Chandraghanta Puja': 'This day worships Goddess Chandraghanta, a symbol of courage and protection. Devotees perform rituals to ward off evil forces and enhance bravery, harmony, and peace in family and social life.',
    'Vinayaka Chaturthi': 'Lord Ganesha is worshipped for the removal of obstacles and success in ventures. Devotees offer sweets like modaks, chant mantras, and seek wisdom, auspicious beginnings, and protection from challenges.',
    'Kushmanda Puja': 'Goddess Kushmanda, who is believed to have created the universe, is worshipped. Devotees perform special prayers, offer sweets, flowers, and fruits to seek health, prosperity, and spiritual enlightenment.',
    'Upang Lalita Vrat': 'This vrata is observed for devotion towards Lalita Devi. Rituals include fasting, prayers, and recitation of Lalita Sahasranama. Devotees seek blessings for spiritual and material growth.',
    'Skandamata Puja': 'Worship of Goddess Skandamata, mother of Kartikeya, symbolizes motherly love and nurturing energy. Devotees offer milk, sweets, and flowers, seeking protection and prosperity for children and family.',
    'Katyayani Puja': 'Goddess Katyayani, a warrior goddess, is worshipped for the destruction of evil and attainment of strength, courage, and righteousness.',
    'Saraswati Avahan': 'Invocation of Goddess Saraswati, goddess of wisdom and learning. Devotees recite hymns, offer books and instruments, and pray for knowledge, success, and artistic skills.',
    'Kalaratri Puja': 'Goddess Kalaratri, the fiercest form of Durga, is worshipped to destroy ignorance, negativity, and fear. Devotees chant mantras and perform rituals seeking spiritual growth and protection.',
    'Saraswati Puja': 'This puja emphasizes the worship of knowledge, music, and arts. Devotees, especially students, place books, pens, and musical instruments near the Goddess and pray for wisdom and creativity.',
    'Durga Ashtami': 'Durga Ashtami is the most powerful day of Navratri. Devotees worship Mahagauri form of Durga, perform Kumari Puja, fast, and engage in prayers and rituals to invoke divine energy for protection, prosperity, and spiritual upliftment.',
    'Mahagauri Puja': 'Goddess Mahagauri, symbolizing purity and calmness, is worshipped with devotion. Devotees offer white flowers, sweets, and recite prayers seeking inner peace, health, and prosperity.',
    'Sandhi Puja': 'Sandhi Puja is performed at the juncture of Ashtami and Navami tithis, considered highly sacred. Devotees light 108 lamps, chant mantras, and offer prayers to harness the maximum divine energy of the Goddess.',
    'Maha Navami': 'Maha Navami marks the final rituals before Durga’s victory. Grand pujas, fire rituals, and community celebrations are conducted, seeking divine blessings for success, courage, and well-being.',
    'Ayudha Puja': 'Tools, vehicles, and weapons are worshipped to seek blessings for skill, safety, and success in endeavors. Devotees clean and decorate tools, symbolizing respect for work and diligence.',
    'Navami Homa': 'A sacred fire ritual performed to conclude Navratri pujas. Offerings are made into fire while chanting mantras to invoke divine blessings and spiritual purification.',
    'Navratri Parana': 'Formal conclusion of Navratri fasting and rituals. Devotees break their fast, perform prayers, and offer gratitude to the Goddess for protection, strength, and guidance.',
    'Durga Visarjan': 'Immersion of Goddess Durga idol signifies her return to the celestial abode. Devotees participate in processions, chant hymns, and bid farewell, reflecting on the triumph of good over evil.',
    'Vijayadashami': 'Celebrates the victory of good over evil. People take part in cultural performances, processions, and festivities, remembering Durga’s triumph over Mahishasura and reaffirming moral values and righteousness.'
  };
  

  useEffect(() => {
    const fetchShardiyaNavratri = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `https://core-c343.onrender.com/api/navratri?year=${year}`
        );
        setNavratriData(response.data.NavaratriDates || []);
      } catch (error) {
        console.error('Error fetching Shardiya Navratri data:', error);
        setNavratriData([]);
      }
      setLoading(false);
    };

    fetchShardiyaNavratri();
  }, [year]);

    const handleSubmit = () => {
  setYear(tempYear);
};

  const handleEventClick = (eventName) => {
    setSelectedEvent(eventName);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setSelectedEvent(null);
    setIsModalOpen(false);
  };

  return (
    <div className="Shardiya-container">
      <InnerNav />
      <div className="Shardiya-content">
        <div className="year-selector">
        <label htmlFor="year">Select Year: </label>
        <input
          id="year"
          type="number"
          min="1900"
          max="2100"
          value={tempYear}
          onChange={(e) => setTempYear(Number(e.target.value))}
        />
        <button className="submit" onClick={handleSubmit}>Submit</button>
      </div>

        <h1 className="s-heading">{year} Shardiya Navratri</h1>

        {loading ? (
          <p>Loading...</p>
        ) : navratriData.length === 0 ? (
          <p className="no-data-msg">❌ No Shardiya Navratri data available for {year}.</p>
        ) : (
          navratriData.map((item, index) => (
            <div className="Shardiya-card" key={index}>
              <div className="card-header">Shardiya Day {item.day}</div>

              <div className="card-body">
                <div className="s-right-section">
                  <div className="s-badge">{item.day}</div>
                  <img
                    src="https://img.etimg.com/photo/msid-119987877,imgsize-101934/ChaitraNavratri2025.jpg"
                    alt="Goddess"
                  />
                </div>

                <div className="s-details">
                  <div className="s-tithi">{item.tithi}</div>
                 <ul className="s-festivals">
                    {item.events.map((event, idx) => (
                      <li key={idx} className="tooltip-wrapper">
                        <span
                          className="event-text"
                          onClick={() => handleEventClick(event)}
                          style={{ cursor: 'pointer', textDecoration: 'underline #ef1313ff', color: '#f61313ff' }}
                        >
                          {event}
                        </span>
                        {eventSignificanceMap[event] && (
                          <span className="tooltip">{eventSignificanceMap[event]}</span>
                        )}
                      </li>
                    ))}
                  </ul>


                  {item.sandhi_puja_timings && (
                    <div className="s-timings">
                      Sandhi Puja: {item.sandhi_puja_timings.start} - {item.sandhi_puja_timings.end}
                    </div>
                  )}

                  {item.color && (
                    <div className="s-color">Suggested Color: {item.color}</div>
                  )}
                </div>

                <div className="date-box">
                  <div className="date">
                    {new Date(item.date).getDate()}
                    <sup>th</sup>
                  </div>
                  <div className="month-year">
                    {new Date(item.date).toLocaleString('default', {
                      month: 'long',
                      year: 'numeric',
                    })}
                  </div>
                  <div className="weekday">{item.weekday}</div>
                </div>
              </div>
            </div>
          ))
        )}

        <CalenderLinks />
      </div>
      <Footer />
          {isModalOpen && selectedEvent && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h2>{selectedEvent}</h2>
            <p>{popups[selectedEvent]}</p>
            <button className="close-btn" onClick={handleCloseModal}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Shardiya;
